<template>
  <div v-cloak>
    <transition appear appear-active-class="fade-enter-active" name="fade">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap">
          <h1 v-if="config.id != null">
            <div>Редактирование<br> конфигурации id {{ config.id }}</div>
          </h1>
          <h1 v-else>
            <div>Создание конфигурации мониторинга
              <v-btn outlined @click="$refs['fileInput'].click()">загрузить файл конфигурации</v-btn>
              <input ref="fileInput" style="display: none" type="file" @change="loadJson">
            </div>
          </h1>

          <div v-if="config.id != null" class="creation-date">Дата создания<span>{{config.createdDate | dateFormat}}</span></div>

          <v-row>
            <v-col cols="12" lg="2">
              <div class="date-range-label">Период действия</div>
              <v-menu
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  min-width="auto"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-on="on"
                      v-bind="attrs"
                      :value="config.startDate | dateFormat"
                      clearable
                      label=""
                      prepend-icon="mdi-calendar"
                      readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="config.startDate"
                    :max="maxDate"
                    :min="minDate"
                    locale="ru-RU"
                    no-title
                    scrollable
                    @input="startDateMenu=false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>


            <v-col cols="12" lg="2">
              <v-menu
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  min-width="auto"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-on="on"
                      v-bind="attrs"
                      :value="config.endDate | dateFormat"
                      clearable
                      label=""
                      prepend-icon="mdi-calendar"
                      readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="config.endDate"
                    :max="maxDate"
                    :min="minDate"
                    locale="ru-RU"
                    no-title
                    scrollable
                    @input="endDateMenu=false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>

          </v-row>


          <div class="list config">
            <div v-for="(direction, directionIndex) in config.directions" :key="direction.id" class="list-item-wrap">

              <v-expansion-panels>
                <v-expansion-panel
                    :key="direction.id"
                >
                  <v-expansion-panel-header @keyup.space.prevent inside>

                    <div class="list-item">
                      <div class="list-item-name">
                        <button class="toggleSwitch">
                          <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                          </svg>
                          <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                          </svg>
                        </button>
                        <span><h4 v-if="directionIndex===0">Направления</h4>
                      <q>{{ direction.id / 100 }}.</q><v-text-field
                              v-model="direction.name" @click.stop=""></v-text-field></span>
                        <div v-if="config.directions.length > 1"
                             class="delete"
                             @click.stop="deleteDirection(direction.id)">
                          <v-icon class="icon-item icon-delete-outline"></v-icon>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(action, actionIndex) in direction.actions"
                                         :key="direction.id+'.'+action.id" class="level2">
                        <div class="list-item-wrap">
                          <v-expansion-panel-header @keyup.space.prevent inside>
                            <div class="list-item">
                              <div class="list-item-name">
                                <button class="toggleSwitch whiteBg">
                                  <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                                  </svg>
                                  <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                                  </svg>
                                </button>
                                <span><h4
                                    v-if="actionIndex===0">Мероприятия</h4><q>{{ direction.id / 100 }}.{{ action.id / 100 }}.</q><v-text-field
                                    v-model="action.name" @click.stop=""></v-text-field></span>
                                <div v-if="direction.actions.length>1" class="delete" @click="deleteAction(direction.id, action.id)"
                                     @click.stop="">
                                  <v-icon class="icon-item icon-delete-outline"></v-icon>
                                </div>
                              </div>
                            </div>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content class="level3">


                            <table class="config-table">
                              <thead>
                              <tr>
                                <th colspan="2">Этапы</th>
                                <th>Тип этапа</th>
                                <th></th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="stage in action.stages" :key="direction.id+'.'+action.id+'.'+stage.id">
                                <td>{{ direction.id / 100 }}.{{ action.id / 100 }}.{{ stage.id / 100 }}.</td>
                                <td>
                                  <v-text-field v-model="stage.name"></v-text-field>
                                </td>
                                <td>
                                  <v-select
                                      v-model="stage.type"
                                      :items="indicatorTypes"
                                      hide-details
                                      item-text="name"
                                      item-value="id"
                                      label="Тип"
                                      menu-props="auto"
                                      single-line
                                  ></v-select>
                                </td>
                                <td>
                                  <div v-if="action.stages.length>1" class="delete"
                                       @click="deleteStage(direction.id, action.id, stage.id)">
                                    <v-icon class="icon-item icon-delete-outline"></v-icon>
                                  </div>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                            <a class="configAdd" href="#" @click.prevent="addStage(action)">+ Добавить этап</a>
                          </v-expansion-panel-content>

                        </div>
                        <a v-if="actionIndex===direction.actions.length-1" class="configAdd" href="#"
                           @click.prevent="addAction(direction)">+ Добавить мероприятие</a>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>


                </v-expansion-panel>
              </v-expansion-panels>
            </div>


            <a class="configAdd" href="#" @click.prevent="addDirection()">+ Добавить направление</a>


          </div>


          <div class="save-buttons mt-24">
            <v-btn color="primary" outlined @click="$router.push('/config/monitoring')">Отмена</v-btn>
            <v-btn :disabled="submitButtonDisabled" color="primary" @click="submit">Сохранить</v-btn>
          </div>
        </div>
        <div class="error" style="position: fixed;bottom: 0" v-if="errorText!=null">
          Ошибка: {{errorText}}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
  </div>
</template>

<style lang="scss">
@import "../../styles/main.scss";
</style>

<style lang="scss" scoped>
</style>

<script>

export default {
  name: "MonitoringConfig",
  props: {},
  components: {},
  data() {
    return {
      indicatorTypes: [
        {id: 0, name: "Общий (неспецифический)"},
        {id: 1, name: "	Информация об утверждении"},
        {id: 2, name: "	Информация о включении в план закупок"},
        {id: 3, name: "	Информация о размещении тендера"},
        {id: 4, name: "	Информация о заключении контракта"},
        {id: 5, name: "	Информация об исполнении контракта"},
        {id: 6, name: "	Информация о размещении сведений"}
      ],
      config: {
        id: null,
        startDate: null,
        endDate: null,
        directions: [{id:100, name:"", actions: [{id:100, name: "", stages:[{id:100,name:"",type:0}]}]}]
        //directions: [{"id":100,"name":"Текущий ремонт зданий и помещений пилотных центров","actions":[{"id":100,"name":"Утверждение дизайн-проекта","stages":[{"id":100,"name":"Разработка дизайн-проекта","type":0},{"id":200,"name":"Утверждение дизайн-проекта","type":1}]},{"id":200,"name":"Размещение тендера (тендеров) на ремонт","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":300,"name":"Заключение контракта (контрактов) на ремонт","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":400,"name":"Сдача объекта","stages":[{"id":100,"name":"Сдача бъекта","type":0}]},{"id":500,"name":"Готовность к предоставлению материалов для итогового рейтинга","stages":[{"id":100,"name":"Исполнение","type":0}]}]},{"id":200,"name":"Оснащение рабочих мест сотрудников служб занятости и помещений","actions":[{"id":100,"name":"Размещение тендера (тендеров) по технике и оборудованию для рабочих мест, залов ожидания, конференц-залов","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":200,"name":"Размещение тендера (тендеров) по мебели для рабочих мест, залов ожидания, конференц-залов","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":300,"name":"Размещение тендера (тендеров) по созданию системы навигации","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":400,"name":"Размещение тендера (тендеров) по обеспечению работников центров занятости населения, в которых реализуются проекты по модернизации, униформой","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":500,"name":"Заключение контракта (контрактов) по технике и оборудованию","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":600,"name":"Заключение контракта (контрактов) по мебели","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":700,"name":"Заключение контракта (контрактов) по системе навигации","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":800,"name":"Заключение контракта (контрактов) по обеспечению работников центров занятости населения, в которых реализуются проекты по модернизации, униформой","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":900,"name":"Поставка техники и оборудования","stages":[{"id":100,"name":"Исполнение контракта (поставка техники)","type":5}]},{"id":1000,"name":"Поставка мебели","stages":[{"id":100,"name":"Исполнение контракта (поставка мебели)","type":5}]},{"id":1100,"name":"Поставка навигационных указателей","stages":[{"id":100,"name":"Исполнение контракта (навигационных указателей)","type":5}]},{"id":1200,"name":"Наладка техники и оборудования","stages":[{"id":100,"name":"Наладка техники и оборудования","type":0}]},{"id":1300,"name":"Сборка и расстановка мебели","stages":[{"id":100,"name":"Сборка и расстановка мебели","type":0}]},{"id":1400,"name":"Установка навигационных указателей","stages":[{"id":100,"name":"Установка навигационных указателей","type":0}]},{"id":1500,"name":"Обеспечение работников центров занятости населения, в которых реализуются проекты по модернизации, униформой","stages":[{"id":100,"name":"Обеспечение работников центров занятости населения, в которых реализуются проекты по модернизации, униформой","type":0}]},{"id":1600,"name":"Готовность к предоставлению материалов для итогового рейтинга","stages":[{"id":100,"name":"Исполнение","type":0}]}]},{"id":300,"name":"Организационное и методическое сопровождение внедрения - ИТ","actions":[{"id":100,"name":"Доработка региональных автоматизированных информационных систем с целью предоставления государственной услуги содействия гражданам в поиске подходящей работы, а работодателям в подборе необходимых работников через ИАС ОБВ \"Работа в России\" в электронной форме, включая автоматизацию информационного обмена между региональной и федеральной системой","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":200,"name":"Регистрация центра занятости населения, в котором реализуются проекты по модернизации, в качестве центра обслуживания ЕСИА","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":300,"name":"Размещение тендера на поставку электронной очереди (ЭО)","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":400,"name":"Размещение тендера на поставку системы аудио-визуального контроля","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":500,"name":"Размещение тендера на поставку системы обеспечения оценки качества услуг ЦЗН (анкетирование)","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":600,"name":"Размещение тендера на поставку контакт-центра","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":700,"name":"Размещение тендера на поставку оборудования и/или ПО для обеспечения защищенных каналов связи","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":800,"name":"Размещение тендера на поставку оборудования для обустройства зоны цифровых сервисов для обеспечения планируемого потока подачи заявлений на получение государственной услуги по содействию в поиске подходящей работы через личный прием","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":900,"name":"Размещение тендера (тендеров) по приведению сайтов в соответствие брендбуку \"Работа России\"","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":1000,"name":"Заключение контракта по ЭО","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":1100,"name":"Заключение контракта по системе аудио-визуального контроля","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":1200,"name":"Заключение контракта по системе обеспечения оценки качества услуг ЦЗН","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":1300,"name":"Заключение контракта по контакт-центру","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":1400,"name":"Заключение контракта по оборудованию и/или ПО для обеспечения защищенных каналов связи","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":1500,"name":"Заключение контракта по оборудованию для обустройства зоны цифровых сервисов для обеспечения планируемого потока подачи заявлений на получение государственной услуги по содействию в поиске подходящей работы через личный прием","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":1600,"name":"Заключение контракта (контрактов) по приведению сайтов в соответствие брендбуку \"Работа России\"","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":1700,"name":"Ввод в эксплуатацию ЭО","stages":[{"id":100,"name":"Ввод в эксплуатацию","type":0}]},{"id":1800,"name":"Ввод в эксплуатацию системы аудио-визуального контроля","stages":[{"id":100,"name":"Ввод в эксплуатацию","type":0}]},{"id":1900,"name":"Ввод в эксплуатацию системы обеспечения оценки качества услуг ЦЗН","stages":[{"id":100,"name":"Ввод в эксплуатацию","type":0}]},{"id":2000,"name":"Ввод в эксплуатацию контакт-центра","stages":[{"id":100,"name":"Ввод в эксплуатацию","type":0}]},{"id":2100,"name":"Установка оборудования, наладка ПО для обеспечения защищенных каналов связи","stages":[{"id":100,"name":"Установка оборудования, наладка ПО","type":0}]},{"id":2200,"name":"Приведение сайтов в соответствие брендбуку \"Работа России\"","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":2300,"name":"Обустройство зоны цифровых сервисов с достаточным количеством рабочих мест и пропускной способностью каналов связи, позволяющим обслужить\nпланируемый поток подачи заявлений на получение государственной услуги по содействию в поиске подходящей работы через личный прием","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":2400,"name":"Методическое обеспечение формирования системы контроля и оценки качества предоставления комплексов услуг, включая разработку правовой базы для\nключевых показателей эффективности центра занятости населения, в котором реализуются проекты по модернизации, отделов и работников такого центра, сбора\nи обработки информации для расчета данных ключевых показателей эффективности","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":2500,"name":"Готовность к предоставлению материалов для итогового рейтинга","stages":[{"id":100,"name":"Исполнение","type":0}]}]},{"id":400,"name":"Организационное и методическое сопровождение внедрения - Процессы","actions":[{"id":100,"name":"Утверждение плана перспективного развития органов службы зантости населения","stages":[{"id":100,"name":"Разработка плана развития","type":0},{"id":200,"name":"Утверждение плана развития","type":1}]},{"id":200,"name":"Утверждение пилотных жизненных ситуаций (ЖС) и пилотных бизнес-ситуаций (БС), перечня услуг, входящих в пилотные ЖС и БС и плана внедрения ЖС и БС","stages":[{"id":100,"name":"Подготовка перечня возможных вариантов","type":0},{"id":200,"name":"Утверждение пилотных вариантов","type":1}]},{"id":300,"name":"Утверждение не менее 2 сервисов для граждан (в рамках ЖС) и 2 сервисов для работодателей (в рамках БС) и дорожной карты их внедрения","stages":[{"id":100,"name":"Подготовка перечня возможных вариантов","type":0},{"id":200,"name":"Утверждение пилотных вариантов","type":1}]},{"id":400,"name":"Размещение тендера на методическое сопровождение (при необходимости)","stages":[{"id":100,"name":"Включение в план закупок","type":2},{"id":200,"name":"Размещение на торгах","type":3},{"id":300,"name":"Подведение итогов торгов","type":0}]},{"id":500,"name":"Заключение контракта на методическое сопровождение (при необходимости)","stages":[{"id":100,"name":"Заключение контракта","type":4}]},{"id":600,"name":"Утверждение карт услуг (процессов), блок-схем услуг (процессов) рамках ЖС и БС","stages":[{"id":100,"name":"Подготовка материалов","type":0},{"id":200,"name":"Утверждение материалов","type":1}]},{"id":700,"name":"Утверждение техносхем; порядка межведомственного информационного взаимодействия при предоставлении комплекса услуг в рамках пилотных ЖС и БС (при необходимости) и соглашений с поставщиками услуг в рамках пилотных ЖС и БС (при необходимости)","stages":[{"id":100,"name":"Подготовка материалов","type":0},{"id":200,"name":"Утверждение материалов","type":1}]},{"id":800,"name":"Утверждение скриптов для сотрудников для тестовых испытаний","stages":[{"id":100,"name":"Подготовка материалов","type":0},{"id":200,"name":"Утверждение материалов","type":1}]},{"id":900,"name":"Приказ о проведении тестовых испытаний","stages":[{"id":100,"name":"Подготовка проекта приказа","type":0},{"id":200,"name":"Утверждение приказа","type":1}]},{"id":1000,"name":"Отчет о проведении тестовых испытаний  (оказание не менее 3 услуг по каждой пилотной ЖС и БС)","stages":[{"id":100,"name":"Проведение тестовых испытаний","type":0},{"id":200,"name":"Подготовка отчета","type":1}]},{"id":1100,"name":"Утверждение итоговых приказов органа занятости о предоставлении услуг и новых сервисов в рамках ЖС и БС, включая стандарт оказания услуг в рамках ЖС и БС, скрипты, технокарты, перечень соглашений с провайдерами услуг","stages":[{"id":100,"name":"Подготовка проекта приказа","type":0},{"id":200,"name":"Утверждение приказа","type":1}]},{"id":1200,"name":"Готовность к предоставлению материалов для итогового рейтинга","stages":[{"id":100,"name":"Подготовка и направление материалов","type":0}]}]},{"id":500,"name":"Обучение","actions":[{"id":100,"name":"Оборудование помещения системой видеоконференцсвязи для проведения дистанционных занятий ","stages":[{"id":100,"name":"Подготовка помещения","type":0},{"id":200,"name":"Оборудование помещения","type":0}]},{"id":200,"name":"Формирование групп и направление на обучение по программам обучения, реализуемым на федеральном уровне: руководителей, заместителей руководителей, работников центров занятости населения, в которых реализуются проекты по модернизации","stages":[{"id":100,"name":"Формирование групп для обучения","type":0},{"id":200,"name":"Направление групп на обучение","type":0}]}]},{"id":600,"name":"Информирование и публичные мероприятия","actions":[{"id":100,"name":"Утверждение плана информационного (включая медиа-) сопровождения деятельности ЦЗН до декабря 2021 г.","stages":[{"id":100,"name":"Подготовка плана","type":0},{"id":200,"name":"Утверждение плана","type":1}]},{"id":200,"name":"Информация на официальном сайте Правительства субъекта РФ о проведенных преобразованиях","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":300,"name":"Изменение стилистики официального сайта ЦЗН в соответствии с фирменным стилем бренда \"Работа (в) России\"","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":400,"name":"Информация на официальном сайте ЦЗН об особенностях работы пилотного центра","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":500,"name":"Информация на официальном сайте ЦЗН о предоставлении услуг по принципу ЖС и БС","stages":[{"id":100,"name":"Исполнение","type":0}]},{"id":600,"name":"Размещение в местных СМИ материалов об успехах модернизации СЗН ( не менее 5 материалов)","stages":[{"id":100,"name":"Разработка информационных материалов","type":0},{"id":200,"name":"Размещение в СМИ","type":6}]},{"id":700,"name":"Изготовление двух тиражей печатных материалов (лифлеты, буклеты и т.п.) для 2 целевых аудиторий (работодателей и граждан) о новых подходах в работе СЗН, в том числе информирующих о предоставлении услуг по ЖС и БС ","stages":[{"id":100,"name":"Разработка макетов печатных материалов","type":0},{"id":200,"name":"Печать материалов","type":0}]},{"id":800,"name":"Торжественное открытие пилотного Центра занятости населения","stages":[{"id":100,"name":"Подготовка к открытию ЦЗН","type":0},{"id":200,"name":"Торжественное открытие ЦЗН","type":0}]},{"id":900,"name":"Проведение мероприятия для работодателей / партнеров (информирование о модернизации работы СЗН)","stages":[{"id":100,"name":"Организация мероприятия","type":0},{"id":200,"name":"Проведение мероприятия","type":0}]},{"id":1000,"name":"Готовность к предоставлению материалов для итогового рейтинга","stages":[{"id":100,"name":"Исполнение","type":0}]}]}]
      },
      startDateMenu: false,
      endDateMenu: false,
      minDate: '2019-01-01',
      maxDate: '2030-12-31',
      errorText: null,
      submitButtonDisabled: false,
      apiLoaded: false
    };
  },
  filters: {
    dateFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },
  methods: {
    //удаляет направление из конфига
    deleteDirection(directionId) {
      for (let i = 0; i < this.config.directions.length; i++) {
        if (this.config.directions[i].id === directionId) {
          this.config.directions.splice(i, 1)
          break
        }
      }
      this.ordinateNumbers()
      this.$forceUpdate()
    },

    deleteAction(directionId, actionId) {
      for (let direction of this.config.directions) {
        if (direction.id === directionId) {
          for (let i = 0; i < direction.actions.length; i++) {
            if (direction.actions[i].id === actionId) {
              direction.actions.splice(i, 1)
              break;
            }
          }
          break
        }
      }
      this.ordinateNumbers()
      this.$forceUpdate()
    },

    deleteStage(directionId, actionId, stageId) {
      for (let direction of this.config.directions) {
        if (direction.id === directionId) {
          for (let action of direction.actions) {
            if (action.id === actionId) {
              for (let i = 0; i < action.stages.length; i++) {
                if (action.stages[i].id === stageId) {
                  action.stages.splice(i, 1)
                  break;
                }
              }
              break;
            }
          }
          break
        }
      }
      this.ordinateNumbers()
      this.$forceUpdate()
    },

    addDirection() {
      if(this.config.directions == null){
        this.config.directions=[]
      }
      this.config.directions.push({
        id: 100,
        name: "",
        actions: [{id: 100, name: "", stages: [{id: 100, name: "", type: 0}]}]
      })
      this.ordinateNumbers()
      this.$forceUpdate();
    },

    addAction(direction) {
      direction.actions.push({id: 100, name: "", stages: [{id: 100, name: "", type: 0}]})
      this.ordinateNumbers()
      this.$forceUpdate();
    },

    addStage(action) {
      action.stages.push({id: 100, name: "", type: 0})
      this.ordinateNumbers()
      this.$forceUpdate();
    },

    //после удаления какого-то элемента порядок номеров направлений-этапов-подэтапов собъется. Нужно все снова расставить
    //при добавлении аналогично
    ordinateNumbers() {
      for (let i = 0; i < this.config.directions.length; i++) {
        let direction = this.config.directions[i]
        direction.id = i * 100 + 100
        for (let j = 0; j < direction.actions.length; j++) {
          let action = direction.actions[j]
          action.id = j * 100 + 100
          for (let k = 0; k < action.stages.length; k++) {
            let stage = action.stages[k]
            stage.id = k * 100 + 100
          }
        }
      }
    },

    validate(directions) {
      if (directions == null || directions.length < 1) {
        return "Должно быть хотя бы одно направление"
      }
      for (let i = 0; i < directions.length; i++) {
        let direction = directions[i]
        if (direction.id !== i * 100 + 100) {
          return "Идентификаторы должны быть кратны 100 и следовать по порядку"
        }
        if (direction.name == null || direction.name.length === 0) {
          return "Должны быть указаны названия всех элементов"
        }
        for (let j = 0; j < direction.actions.length; j++) {
          let action = direction.actions[j]
          if (action.id !== j * 100 + 100) {
            return "Идентификаторы должны быть кратны 100 и следовать по порядку"
          }
          if (action.name == null || action.name.length === 0) {
            return "Должны быть указаны названия всех элементов"
          }
          for (let k = 0; k < action.stages; k++) {
            let stage = action.stages[k]
            if (stage.id !== k * 100 + 100) {
              return "Идентификаторы должны быть кратны 100 и следовать по порядку"
            }
            if (stage.name == null || stage.name.length === 0) {
              return "Должны быть указаны названия всех элементов"
            }
          }
        }
      }
      return true
    },

    loadJson() {
      let file = this.$refs['fileInput'].files[0];
      let reader = new FileReader();
      reader.readAsText(file);
      reader.componentThis = this
      reader.onload = function () {
        let directions

        try {
          directions = JSON.parse(reader.result)
        } catch (e) {
          reader.componentThis.errorText = "Файл должен содержать конфигурацию в формате JSON"
          return
        }
        // console.log(directions)
        let validstat = reader.componentThis.validate(directions)
        if (validstat === true) {
          reader.componentThis.config.directions = directions
        } else {
          reader.componentThis.errorText = validstat
        }
      };

      reader.onerror = function () {
        alert('Ошибка загрузки файла')
      };
    },

    async submit() {
      let valstat = this.validate(this.config.directions)
      if (valstat === true) {
        this.config.directionsJson = JSON.stringify(this.config.directions)
        this.submitButtonDisabled = true
        let req = await this.$postApi("/monitoring/saveConfig", this.config)
        if (req.ok) {
          this.$router.push("/config/monitoring")
        } else {
          this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
          this.submitButtonDisabled = false
        }
      } else {
        this.errorText = valstat
      }
    }
  },
  async beforeMount() {
    if (this.$route.params.id != null) {
      //режим редактирования
      let req = await this.$getApi("/monitoring/getConfig", {id: this.$route.params.id})
      if (req.ok) {
        this.config = req.payload
        this.config.directions = JSON.parse(this.config.directionsJson)
        this.apiLoaded = true
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    } else {
      this.apiLoaded = true
    }
  }
};
</script>
